<template>
  <div :class="cn('flex items-center justify-between bg-violet-600 p-5 text-white shadow-lg', props.class)">
    <div class="flex gap-2">
      <UiNuxtIcon class="translate-y-0.5" :name="'portfolio/coins-filled'" />

      <div class="flex flex-col items-start gap-2 text-sm">
        <span class="font-medium" v-html-format="t('cashback_title')" />
        <p class="font-light" v-html-format="t('cashback_description')" />
      </div>
    </div>
    <div class="ml-3 flex-shrink-0">
      <NuxtImg class="h-16 object-cover" loading="lazy" :src="getImageUrl('/logo-finq-shiny.png')" />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ class?: ClassValue }>()
const { t } = useI18n()
</script>

<i18n lang="json">
{
  "he": {
    "cashback_title": "25% מההכנסות שלנו חוזרות ישירות אליך",
    "cashback_description": "אנחנו מקבלים עמלות כמו כל סוכנות פנסיונית, אבל בלי להעדיף\n:min-md אף חברה – כולם משלמים לנו אותו דבר. מתוך שקיפות ושותפות\n:min-md אמיתית, אנחנו מחזירים לך חלק מהעמלות."
  }
}
</i18n>
